interface IDictionary {
  [index: string]: string
}

export const offerStatusColors: IDictionary = {
  valid: 'gray.100',
  selected: 'green.100',
  error: 'red.100',
}
